// Shared option/label maps for entity form dropdowns and the read-only view page.
// Values mirror pkg/models (BusinessLegalType, PEPStatus) and the entity OpenAPI spec.

export interface LabeledOption {
  label: string;
  value: string;
}

export const BUSINESS_LEGAL_TYPE_OPTIONS: LabeledOption[] = [
  { label: 'Corporation', value: 'corporation' },
  { label: 'LLC', value: 'llc' },
  { label: 'Limited Partnership', value: 'limited-partnership' },
  { label: 'General Partnership', value: 'general-partnership' },
  { label: 'Sole Proprietorship', value: 'sole-proprietorship' },
  { label: 'Trust', value: 'trust' },
  { label: 'Revocable Trust', value: 'revocable_trust' },
  { label: 'Irrevocable Trust', value: 'irrevocable_trust' },
  { label: 'Professional Association', value: 'professional-association' },
  { label: 'PIC / PIV', value: 'pic-piv' },
  { label: 'SPV', value: 'spv' },
  { label: 'Government', value: 'government' },
  { label: 'Non-Profit', value: 'non-profit' },
  { label: 'Other', value: 'other' },
];

export const PEP_STATUS_OPTIONS: LabeledOption[] = [
  { label: 'Not Checked', value: 'not_checked' },
  { label: 'No', value: 'no' },
  { label: 'Yes', value: 'yes' },
  { label: 'Potential', value: 'potential' },
];

// expected_payment_rails is persisted as a comma-separated string of these values.
export const PAYMENT_RAIL_OPTIONS: LabeledOption[] = [
  { label: 'ACH', value: 'ach' },
  { label: 'Wire', value: 'wire' },
  { label: 'International Wire', value: 'swift' },
  { label: 'Check', value: 'check' },
  { label: 'Realtime', value: 'rtp' },
  { label: 'Card Spend', value: 'card_spend' },
];

// Read the comma-separated expected_payment_rails string as a set of tokens.
export const parsePaymentRails = (value?: string): string[] =>
  value
    ? value
        .split(',')
        .map((rail) => rail.trim())
        .filter((rail) => rail.length > 0)
    : [];

// Canonicalize a set of selected rails to the comma-separated string the API expects,
// preserving the ordering from PAYMENT_RAIL_OPTIONS.
export const railsToString = (rails: string[]): string =>
  PAYMENT_RAIL_OPTIONS.filter((option) => rails.includes(option.value))
    .map((option) => option.value)
    .join(',');
